import { useMemo } from 'react'

import { usePagination } from '@/atoms'

/**
 * This hook returns the orders for the provided selection.
 * If the Navigo is active it also filters the results based on the Navigo paginator
 */
export const useCurrentOrders = (
  selection: string[],
  orderSteps: uui.domain.client.rm.ExtendedOrderStep[],
) => {
  const { page } = usePagination('navigo')
  const orders = useMemo(() => Object.fromEntries(orderSteps.map(o => [o.id, o])), [orderSteps])

  return useMemo(() => {
    const selectedOrders = selection.reduce<uui.domain.client.rm.ExtendedOrderStep[]>((acc, id) => {
      !!orders[id] && acc.push(orders[id])
      return acc
    }, [])

    const currentOrder = selectedOrders[page]

    if (page === -1 || !currentOrder) return selectedOrders

    return [currentOrder]
  }, [orders, selection, page])
}
